export default __webpack_public_path__ + "static/media/asiacup-yoko.00470c90.png";